<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose">
    <h4 slot="header" class="title title-up">
      Add New Disciple
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <el-row>
      <label class="col-md-4 col-form-label">New Disciple</label>
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="newDisciplePersonId"
        placeholder="Select disciple..."
      >
        <el-option
          v-for="item in addableDisciples"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-row>
    <p
      class="
      col-md-12 note"
    >
      *If your new disciple isn't on this list, please add them into the People tab.
    </p>
    <p>Is this person a Growing Disciple or a Commissioned Disciple?</p>
    <div class="text-center">
      <el-radio v-model="newDiscipleType" label="Growing Disciple" />
      <el-radio v-model="newDiscipleType" label="Commissioned Disciple" />
      <p class="note">
        *Only Commissioned Disciples will receive an
        email invite to login and begin using Acts.
      </p>
    </div>
    <span
      v-if="isOneOfTheseRoles(['missionary', 'affiliate', 'chaplain', 'td', 'parish-missionary', 'parish-td'])"
    >
      <el-row>
        <el-checkbox class="col-md-1" v-model="isDiscipler" @change="handleCheck" /><label class="col-form-label">I will be leading this person in discipleship.</label>
      </el-row>
      <el-row v-if="!isDiscipler">
        <label class="col-md-4 col-form-label">New Discipler</label>
        <el-select
          class="col-md-8 select-default"
          filterable
          clearable
          v-model="newDisciplerPersonId"
          placeholder="Type new discipler..."
        >
          <el-option
            v-for="item in addableDisciplers"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-row>
    </span>

    <p>
      <span v-if="validationError.disciple === true" style="color: red;">
        A disciple is required.<br>
      </span>
      <span v-if="validationError.type === true" style="color: red;">
        Please select whether this person is a growing or commissioned disciple.
      </span>
    </p>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Add
      </p-button>
      <p-button type="danger" v-if="saving">
        Adding...
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import { mapState, mapActions, vuex } from 'vuex';
import Modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DisciplesRepository = RepositoryFactory.get('disciples');

function validateDisciple(newDisciplePersonId) {
    return !!newDisciplePersonId;
}

function validateType(newDiscipleType) {
    return !!newDiscipleType;
}

export default {
    name: 'AddNewDiscipleModal',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            material: '',
            validationError: {
                disciple: false,
                type: false
            },
            addableDisciples: [],
            addableDisciplers: [],
            newDisciplePersonId: '',
            newDisciplerPersonId: '',
            newDiscipleType: '',
            isDiscipler: true,
            error: '',
            saving: false,
            testData: true
        };
    },
    computed: {

    },
    methods: {
        handleCheck() {
            if (this.isDiscipler === true) {
                this.newDisciplerPersonId = '';
            }
        },
        handleSave() {
            this.saving = true;
            this.validationError.disciple = !validateDisciple(this.newDisciplePersonId);
            this.validationError.type = !validateType(this.newDiscipleType);
            if (this.validationError.disciple || this.validationError.type) {
                this.saving = false;
                return;
            }

            DisciplesRepository.addDisciple(this.newDisciplePersonId, this.newDisciplerPersonId, this.newDiscipleType)
            // axios.post('/disciples',
            //     {
            //         disciple_person_id: this.newDisciplePersonId,
            //         discipler_person_id: this.newDisciplerPersonId
            //     },
            //     { headers: { Authorization: this.$store.getters.token } })
                .then((response) => {
                    // console.log('yay');
                    this.saving = false;
                    this.$emit('discipleChange');
                    this.$message(response.data.message);
                })
                .catch((error) => {
                    this.saving = false;
                    this.$message(error.response.data.message);
                });

            this.$emit('save');
            this.$emit('close');

            this.newDisciplePersonId = '';
            this.newDisciplerPersonId = '';
            this.newDiscipleType = '';
            this.validationError.disciple = false;
            this.validationError.type = false;
        },
        handleClose() {
            this.newDisciplePersonId = '';
            this.newDisciplerPersonId = '';
            this.newDiscipleType = '';
            this.validationError.disciple = false;
            this.validationError.type = false;
            this.$emit('close');
        },
        getAddableDisciplesList() {
            DisciplesRepository.getAddableDisciplesList()
                .then((response) => {
                    this.addableDisciples = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        getAddableDisciplersList() {
            DisciplesRepository.getAddableDisciplersList()
                .then((response) => {
                    this.addableDisciplers = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getAddableDisciplesList();
                this.getAddableDisciplersList();
            }
        }
    },
    created() {
        // this.getAddableDisciplesList();
        // this.getAddableDisciplersList();
    },
    mounted() {
    }

};
</script>
<style>
.note {
  font-size: .9em;
  color: #66b1ff;
}
</style>
